"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const common_components_1 = require("@zapier/common-components");
function PrettySelectButtonIcon({ selectedApi }) {
    return (react_1.default.createElement(common_components_1.LogoImage, { app: selectedApi, backgroundType: "white", border: true, borderPadding: 4, borderRadius: 6, size: 20 }));
}
exports.default = PrettySelectButtonIcon;
